import { FC } from 'react';
import InnerWrapper from '../../InnerWrapper';
import CreateForm from './components/CreateForm';

const Screen: FC = () => {
  return (
    <InnerWrapper>
      <CreateForm />
    </InnerWrapper>
  );
};

export default Screen;
